<template>
  <div class="item">
    <!--    云店 -->
    <div v-if="type==='0'" class="order_item white" @click='toDetail'>
      <div class="shop_tit pub_left f14 flex space_between label_hr">
        <span class="gray_f">{{item.shopName}}</span>
        <span class="main_co">{{tabItems[type][item.status]}}</span>
      </div>
      <div class="good space_between" v-for="(sitem, i) in item.productList" :key="i">
        <div class="left"><img :src="sitem.coverImage" alt=""></div>
        <div class="right f14">
          <div class="flex space_between text">
            <p class="overell"><b class="main_bg white_f f12" v-if="item.daimai==='1'&&userType!=='1'" style="padding:1px 2px;">代买</b>
              <b class="white_f f12" v-if="sitem.isyg==='1'" style="padding:1px 2px;background-color: #ff8d00;">预</b>
              <b class="white_f f12" v-if="item.ishot==='1'" style="padding:1px 2px;background-color: #6892ff;">爆</b>
              <b>{{sitem.productName}}</b>
            </p>
            <span class="price">￥{{sitem.price}}</span>
          </div>
          <div class="flex space_between text">
            <p class="specs f12 gray_f">{{sitem.specification}}</p>
            <span class="number">X{{sitem.count}}</span>
          </div>
          <div class="pub_left">
            <span class="beneif f12">{{sitem.integral}}铜板</span>
          </div>
        </div>
      </div>
      <div class="flex space_between f14 label_hr" style="padding: 0"><p class="main_co">&nbsp;</p><p>实付：<span class="main_co">￥{{item.payMoney}}</span></p></div>
      <div class="f14 sbot" v-if="userType!=='1'">
        <div class="gray_btn" v-if="item.status==='0'" @click.stop="cancel(item)">取消订单</div>
        <div class="gray_btn" v-if="(item.status==='1'||item.status==='2') && (item.productList[0].isyg==='0'&&item.ishot==='0')" @click.stop="returnMoney(item)">申请退款</div>
        <div class="gray_btn" v-if="item.status==='6'" @click.stop="cancelReturn(item)">取消退款</div>
        <div class="red_btn main_bor main_co" v-if="item.status==='6'" @click.stop="returnDetail(item)">退款中</div>
        <div class="red_btn main_bor main_co" v-if="item.status==='7'" @click.stop="returnDetail(item)">已退款</div>
        <div class="red_btn main_bor main_co" v-if="item.status==='0'" @click.stop="pay(item)">去付款</div>
        <div class="red_btn main_bor main_co" v-if="item.status==='2'" @click.stop="confirm">确认收货</div>
        <div class="red_btn main_bor main_co" v-if="item.status==='3'" @click.stop="goComment">去评价</div>
      </div>
    </div>
<!--     淘客  -->
    <div v-if="type==='1'" class="order_item white" @click='toDetail'>
      <div class="shop_tit pub_left f14 flex space_between label_hr">
        <span class="">{{tktypes[item.type].source}}</span>
        <span class="main_co">{{tkStatus[item.type][item.status]}}</span>
      </div>
        <div class="good space_between label_hr">
          <div class="left"><img :src="item.productImage" alt=""></div>
          <div class="right f14">
            <div class="flex space_between text">
              <p class="overell"><b>{{item.productName}}</b></p>
              <span class="price">￥{{item.price}}</span>
            </div>
            <div class="flex space_between text f12">
              <p class="gray_f">付款日：{{item.payTime}}</p>
              <span class="number">X{{item.num}}</span>
            </div>
            <div class="f12">
<!--              <p class="pub_left gray_f">确认收货日：2019-10-10</p>-->
              <p class="pub_left gray_f">订单号：{{item.orderNum}}</p>
            </div>
          </div>
        </div>
        <div class="f14 flex space_between bot">
<!--下单时间对比-->
          <p v-if="Date.parse(item.adtime)>Date.parse('2020/06/01 00:00:00')&&item.type=='0'">
            <span class="beneif f12" v-if="tktypes[item.type].status===item.status">
              {{item.estimateIncome*m_ztkrateGui?(parseInt(item.estimateIncome*m_ztkrateGui*100))*0.01.toFixed(2):0}}铜板</span>
           <span class="beneif f12" v-else>预估：{{item.pubSharePreFee?(parseInt(item.pubSharePreFee*m_ztkrateGui*100)*0.01).toFixed(2):0}}铜板</span>
          </p>

          <p v-else><span class="beneif f12" v-if="tktypes[item.type].status===item.status">{{item.estimateIncome*m_rate?(parseInt(item.estimateIncome*m_rate*100))*0.01.toFixed(2):0}}铜板</span>
            <span class="beneif f12" v-else>预估：{{item.pubSharePreFee?(parseInt(item.pubSharePreFee*m_rate*100)*0.01).toFixed(2):0}}铜板</span></p>

          <p v-if="item.payMoney">实付：<span class="main_co">￥{{item.payMoney}}</span></p>
        </div>
    </div>
<!--     拼团团员订单  -->
    <div v-if="type==='2'" class="order_item white" @click='toDetail'>
      <div class="shop_tit pub_left f14 label_hr flex space_between">
        <span class="gray_f">{{item.shopName}}</span>
        <span class="main_co">{{tabItems[type][item.status]}}</span>
      </div>
      <div class="good space_between">
        <div class="left"><img :src="item.coverImage" alt=""></div>
        <div class="right f14">
          <div class="flex space_between text">
            <p class="overell"><b>{{item.productName}}</b></p>
            <span class="price">￥{{item.price}}</span>
          </div>
          <div class="flex space_between text">
            <p class="specs f12 gray_f">{{item.specification}}</p>
            <span class="number">X{{item.count}}</span>
          </div>
          <div class="pub_left">
            <span class="beneif f12">{{item.integral}}铜板</span>
          </div>
        </div>
      </div>
      <!--团员-->
      <div class="flex space_between f14 label_hr" style="padding: 0"><p class="main_co">&nbsp;</p><p>实付：<span class="main_co">￥{{item.payMoney}}</span></p></div>
      <!--<div class="f14" style="text-align: right;margin-top: 0.3rem;">-->
        <!--<span class="gray_btn" style="color: #07c160">{{item.ptstatus==='0'?'拼团中':item.ptstatus==='1'?'拼团成功':item.ptstatus==='2'?'拼团失败':''}}</span>-->
      <!--</div>-->
      <div class="flex flex_end">
        <!--<div class="f14 sbot" v-if="item.status!=='0'&&item.status!=='1'&& item.status!=='5'&& item.status!=='6'&&item.status!=='7'">-->
        <!--&lt;!&ndash;<div class="f14 sbot">&ndash;&gt;-->
          <!--<div class="gray_btn" style="margin: 0" >提货码：{{item.thCode}}</div>-->
        <!--</div>-->
        <div class="f14 sbot" v-if="userType!=='1'">
          <div class="gray_btn" v-if="item.status==='0'" @click.stop="cancel(item)">取消订单</div>
          <div class="gray_btn" v-if="item.status==='1'||item.status==='2'" @click.stop="returnMoney(item)">申请退款</div>
          <div class="gray_btn" v-if="item.status==='6'" @click.stop="cancelReturn(item)">取消退款</div>
          <div class="red_btn main_bor main_co" v-if="item.status==='6'" @click.stop="returnDetail(item)">退款中</div>
          <div class="red_btn main_bor main_co" v-if="item.status==='7'" @click.stop="returnDetail(item)">已退款</div>
          <div class="red_btn main_bor main_co" v-if="item.status==='0'" @click.stop="pay(item)">去付款</div>
          <div class="red_btn main_bor main_co" v-if="item.status==='2'" @click.stop="confirm">确认收货</div>
          <div class="red_btn main_bor main_co" v-if="item.status==='3'" @click.stop="goComment">去评价</div>
        </div>
      </div>
    </div>
<!--     拼团团长订单  -->
    <div v-if="type==='21'" class="order_item white" @click='toDetail'>
      <div class="shop_tit pub_left f14 label_hr flex space_between">
        <span class="gray_f">{{item.shopName}}</span>
        <span class="main_co">{{tabItems[type][item.status]}}</span>
      </div>
      <div class="good space_between">
        <div class="left"><img :src="item.productImage" alt=""></div>
        <div class="right f14">
          <div class="flex space_between text">
            <p class="overell"><b>{{item.productName}}</b></p>
            <span class="price">￥{{item.price}}</span>
          </div>
          <div class="flex space_between text">
            <p class="specs f12 gray_f">{{item.sku}}</p>
            <span class="number">X{{item.count}}</span>
          </div>
          <div class="pub_left">
            <!--<span class="beneif f12">拼团服务费：￥{{item.pt_fwmoney}}</span>-->
            <span class="beneif f16" style="margin-top: 0.2rem;">拼团服务费：￥{{item.pt_fwmoney}}&nbsp;&nbsp;3人成团</span>
          </div>
        </div>
      </div>
      <!--团长-->
      <div class="flex space_between f14 label_hr" style="padding: 0"><p class="main_co">&nbsp;</p><p>实付：<span class="main_co">￥{{item.payMoney}}</span></p></div>
      <div class="f14" style="text-align: right;margin-top: 0.3rem;">
        <span class="gray_btn">用户：{{item.gmname}} &nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="gray_btn">电话：{{item.gmphone}}</span>
      </div>
      <div class="flex flex_end">
      <div class="f14 sbot" v-if="item.status!=='0'&&item.status!=='1'&& item.status!=='5'&& item.status!=='6'&&item.status!=='7'">
        <div class="gray_btn" style="margin: 0" >提货码：{{item.th_code}}</div>
      </div>
      <div class="f14 sbot">
        <!--<div class="gray_btn" v-if="item.status==='0'" @click.stop="cancel(item)">取消订单</div>-->
        <!--<div class="gray_btn" v-if="item.status==='1'||item.status==='2'" @click.stop="returnMoney(item)">申请退款</div>-->
        <div class="gray_btn" v-if="item.status==='6'||item.status==='7'" @click.stop="returnDetail(item)">退款详情</div>
        <!--<div class="red_btn main_bor main_co" v-if="item.status==='2'" @click.stop="confirm">确认收货</div>-->
        <!--<div class="red_btn main_bor main_co" v-if="item.status==='3'" @click.stop="goComment">去评价</div>-->
      </div>
      </div>
    </div>
<!--   实体商圈   -->
    <div v-if="type==='3'" class="order_item white">
      <div class="good space_between label_hr">
        <div class="" style="width: 3rem; height: 1.86rem;overflow: hidden;margin-right: .2rem;"><img :src="item.images" alt="" style="width:100%;height: auto;"></div>
        <div class="right f14">
          <div class="flex space_between text">
            <p class="overell"><b>{{item.title}}</b></p>
          </div>
          <div class="flex space_between text f12">
            <p class="gray_f">时&nbsp;&nbsp;&nbsp;&nbsp;间：{{item.pay_date}}</p>
          </div>
          <div class="f12">
            <p class="pub_left gray_f">订单号：{{item.Id}}</p>
          </div>
        </div>
      </div>
      <div class="f14 flex space_between bot">
        <p><span class="beneif f12">{{Number(item.point).toFixed(2)}}铜板</span> <span class="beneif f12" style="color: #f6a200;border: 0.026667rem solid #f6a200">优惠{{Number(item.hyrefee).toFixed(2)}}元</span></p>
        <p>实付：<span class="main_co">￥{{item.price}}</span></p>
      </div>
    </div>
<!--    信用卡-->
    <div class="white card" v-if='type==="444"'>
<!--      <div class="pub_left">-->
<!--        <div class="label_hr"><span>申请卡别：</span><span class="gray_f">{{22}}</span></div>-->
<!--        <div class="label_hr"><span>申请日期：</span><span class="gray_f">{{22}}</span></div>-->
<!--        <div class="label_hr"><span>申请进度：</span><span class="gray_f">{{22}}</span></div>-->
<!--        <div class="label_hr"><span>预估收益：</span><span class="main_co">{{22}}铜板</span></div>-->
<!--      </div>-->
      <div class="pub_left">
        <div class="label_hr"><span>申请卡别：</span><span class="gray_f">{{item.title}}</span></div>
        <div class="label_hr"><span>申请日期：</span><span class="gray_f">{{item.createDate}}</span></div>
        <div class="label_hr"><span>申请进度：</span><span class="gray_f">{{item.state|getState}}</span></div>
        <div class="label_hr"><span>预估收益：</span><span class="main_co">{{item.point*m_rate?(parseInt(item.point*m_rate*100)*0.01).toFixed(2):0}}铜板</span></div>
      </div>
    </div>
<!--    酒店-->
    <div v-if='type==="555"' class="order_item white" @click='toDetail'>
        <div class="shop_tit flex space_between f14 label_hr">
            <div>
                <span class="f14">中州商务酒店</span>
                <span class="beneif f12">17铜板</span>
            </div>
           <span class="main_co f14">待付款</span>
        </div>
        <div class="middle f14">
            <p>传统大床房</p>
            <p>2019-01-01至2019-01-03 共2晚</p>
        </div>
        <div class="s_bot flex space_between">
            <span>预定日期 2018-12-28</span>
            <span class="f16 main_co">￥680</span>
        </div>
    </div>
<!--    机票-->
    <div v-if='type==="666"' class="order_item white plane" @click='toDetail'>
      <div class="shop_tit flex space_between f14 label_hr">
        <div>
          <span class="">航空</span>
        </div>
        <span class="main_co f16">待付款</span>
      </div>
      <div class="middle f14 flex label_hr">
        <div class="left"><img src="../assets/image/hotel/feijibiaoqian.png" alt="" style="width: 0.5rem"></div>
        <div class="right">
          <div class="flex flex_start">
            <span>成都</span>
            <span><img src="../assets/image/hotel/jiantou.png"  style="width: 0.4rem;margin: 0 .3rem" alt=""></span>
            <span>北京</span>
          </div>
          <div class="pub_left">
            <p>四川航空35462</p>
            <p>四川航空35462</p>
          </div>
          <div class="flex flex_end">
            <span class="beneif f12">17.5铜板</span>
            <p>
              <span class="f14">合计：</span>
              <span class="f20 main_co">￥680</span>
            </p>
          </div>
        </div>
      </div>
      <div class="s_bot flex flex_end" v-if="userType!=='1'">
        <div class="f14 main_co btn main_bor" v-if="item.state==='0'">去付款</div>
        <div class="f14 main_co btn main_bor" v-if="item.state==='0'">取消订单</div>
      </div>
    </div>
<!--    火车票-->
    <div v-if='type==="777"' class="order_item white plane" @click='toDetail'>
      <div class="shop_tit flex space_between f14 label_hr">
        <div>
          <span class="">航空</span>
        </div>
        <span class="main_co f16">待付款</span>
      </div>
      <div class="middle f14 flex label_hr">
        <div class="left"><img src="../assets/image/hotel/huochebiaoqian.png" alt="" style="width: 0.5rem"></div>
        <div class="right">
          <div class="flex flex_start">
            <span>成都</span>
            <span><img src="../assets/image/hotel/jiantou.png"  style="width: 0.4rem;margin: 0 .3rem" alt=""></span>
            <span>北京</span>
          </div>
          <div class="pub_left">
            <p>四川航空35462</p>
            <p>四川航空35462</p>
          </div>
          <div class="flex flex_end">
            <span class="beneif f12">17.5铜板</span>
            <p>
              <span class="f14">合计：</span>
              <span class="f20 main_co">￥680</span>
            </p>
          </div>
        </div>
      </div>
      <div class="s_bot flex flex_end" v-if="userType!=='1'">
        <div class="gray_btn" v-if="item.state==='1'">申请退款</div>
        <div class="f14 main_co btn main_bor" v-if="item.state==='0'">去付款</div>
        <div class="f14 main_co btn main_bor" v-if="item.state==='0'">取消订单</div>
<!--        <div class="f14 main_co btn main_bor">取消订单</div>-->
      </div>
    </div>
<!--    拼团 全部 已成团 拼团中 未成团-->
    <div v-if="type==='20'" class="order_item white" @click='toptDingdan(item)'>
      <div class="shop_tit pub_left f14 label_hr flex space_between">
        <span class="gray_f">{{item.shopName}}</span>
        <span class="main_co">{{tabItems[type][item.status]}}</span>
      </div>
      <div class="good space_between label_hr">
        <div class="left"><img :src="item.coverImage" alt=""></div>
        <div class="right f14">
          <div class="flex space_between text">
            <p class="overell"><b>{{item.productName}}</b></p>
            <!--<span class="price">￥{{item.price}}</span>-->
          </div>
          <div class="flex space_between text">
            <p class="specs f12 gray_f">原价：￥{{item.yjprice}}</p>
            <!--<span class="number">X{{item.count}}</span>-->
          </div>
          <div class="pub_left">
            <span class="beneif f16" style="margin-top: 0.2rem;">团价：￥{{item.ptprice}}&nbsp;&nbsp;{{item.RenNum}}人成团</span>
          </div>
        </div>
      </div>
      <div class="f14 sbot">
        <div class="gray_btn" @click.stop="toptDingdan(item)">查看详情</div>
      </div>
    </div>
  </div>
</template>

<script>
import { confirmShouhuo, refundOrder, cancelrefundOrder } from '../api/my'
export default {
  name: 'list',
  props: {
    type: '',
    userType: '',
    item: {}
  },
  data () {
    return {
      tabItems: {
        0: {
          0: '待付款',
          1: '待发货',
          2: '待收货',
          3: '待评价',
          4: '已完成',
          5: '已取消',
          6: '退款/售后'
        },
        1: {
          0: '已付款',
          1: '已结算',
          2: '已失效'
        },
        2: {
          0: '待付款',
          1: '待发货',
          2: '待收货',
          3: '待评价',
          4: '已完成',
          5: '已取消',
          6: '退款/售后'
        },
        3: {
          0: '待付款',
          1: '待使用',
          2: '已使用',
          3: '已过期',
          4: '已退款',
          5: '已取消'
        },
        20: {
          0: '拼团中',
          1: '已成团',
          2: '未成团'
        },
        21: {
          0: '待付款',
          1: '待发货',
          2: '待收货',
          3: '待评价',
          4: '已完成',
          5: '已取消',
          6: '退款/售后'
        }
      },
      tkStatus: {
        0: {
          12: '已付款',
          13: '已失效',
          14: '已完成',
          3: '已结算'
        },
        1: {
          '-1': '未支付',
          '0': '已支付',
          1: '已成团',
          2: '确认收货',
          3: '审核成功',
          4: '审核失败（不可提现）',
          5: '已结算',
          8: '无佣金订单',
          10: '已处罚'
        },
        2: {
          15: '待付款',
          16: '已付款',
          17: '已完成',
          18: '已结算',
          20: '已失效'
        }
      },
      tktypes: {
        0: {source: '天猫 / 淘宝', status: '3'},
        1: {source: '拼多多', status: '5'},
        2: {source: '京东', status: '18'}
      }
      // order_m_rate:''
    }
  },
  filters: {
    getState (val) {
      switch (val) {
        case '0': return '推广订单'
          break
        case '1': return '成功订单'
          break
        case '2': return '失效订单'
          break
      }
    }
  },
  created () {
    // console.log('props'+this.props)
    // this.getztkrateGui()
  },
  methods: {
    // 判断淘宝天猫下单并支付与本次系统升级时间时间对比20200601
    // 淘宝6月1号之前rate是0.35，之后是0.3
    // getztkrateGui() {
    //   var timeStr1 = this.item.adtime
    //   var timeStr2 = '2020/06/01 00:00:00'
    //   var time1 = new Date(timeStr1).getTime()
    //   var time2 = new Date(timeStr2).getTime()
    //   console.log('adtime=' + this.item.type=='0')
    //   console.log(timeStr2)
    //   console.log('this.item.type='+this.item.type)
    //   if (time1 > time2 && this.item.type=='0') {
    //     this.order_m_rate = this.m_ztkrateGui
    //   } else {
    //     this.order_m_rate = this.m_rate
    //   }
    // },

    // 订单详情
    toDetail () {
      if (this.type === '3') {
        this.$router.push({path: '/creditDetail', query: {orderId: this.item.orderId, userType: this.userType}})
      } else if (this.type === '444') {
        // this.$router.push({path: '/Hotel/orderdetail', query: {orderId: this.item.orderId}})
      } else if (this.type === '555') {
        this.$router.push({path: '/airOrderDetail', query: {orderId: this.item.orderId}})
      } else if (this.type === '666') {
        this.$router.push({path: '/trainOrderDetail', query: {orderId: this.item.orderId}})
      } else if (this.type === '0') {
        this.$router.push({path: '/myorder/detail', query: {orderId: this.item.orderId, type: this.type, userType: this.userType}})
      } else if (this.type === '2') {
        this.$router.push({path: '/myorder/ptdetail', query: {orderId: this.item.orderId, type: this.type, userType: this.userType}})
      } else if (this.type === '21') {
        this.$router.push({path: '/myorder/ptdetail', query: {orderId: this.item.orderNum, type: this.type}})
      }else if (this.type === '1') {
        if (this.item.type === '0' || this.item.type === '2') {
          this.$router.push({path: '/goodDetail', query: {productId: this.item.productId, productSign: this.item.goodssign, showType: this.item.type === '0' ? 'ztk' : 'jd'}})
        }else {
          this.$router.push({path: '/goodDetail', query: {productId: this.item.productId, productSign: this.item.goodssign, showType: 'pdd'}})
        }
      }
    },
    toptDingdan(item){
      // this.$router.push('/groupOrder')
      this.$router.push({path: '/groupOrder', query: {groupid: item.groupid}})
    },
    // 取消订单
    cancel (item) {
      this.$router.push({path: '/myorder/cancel', query: {orderId: item.orderId, type: this.type}})
    },
    // 退款
    returnMoney (item) {
      this.$router.push({path: '/Return', query: {orderId: item.orderId, type: this.type, payMoney: item.payMoney ? item.payMoney : item.price}})
    },
    // 商圈退款
    returnCurpon () {
      this.$dialog.confirm({
        title: '提示',
        message: '退款后将不能享受优惠，是否确认？',
        confirmButtonColor: this.m_color
      }).then(() => {
        let data = {
          uid: localStorage.getItem('uid'),
          orderId: this.item.orderId,
          type: '1'
        }
        refundOrder(data).then(res => {
          if (res.result === '0') {
            this.showToast('退款成功')
            this.item.status = '4'
            // this.getDetail()
          }
        })
      }).catch(() => {
        this.showToast('已取消')
      })
    },
    // 付款
    pay (item) {
      this.$router.push({path: '/pay', query: {orderNum: item.orderId, payMoney: item.payMoney ? item.payMoney : item.price}})
    },
    // 确认收货
    confirm () {
      this.$dialog.confirm({
        title: '提示',
        message: '确认已经收到货了吗',
        confirmButtonColor: this.m_color
      }).then(() => {
        let data = {
          uid: localStorage.getItem('uid'),
          orderId: this.item.orderId,
          type: this.type
        }
        confirmShouhuo(data).then(res => {
          if (res.result === '0') {
            this.showToast('已确认收货')
            this.item.status = '3'
            // this.getDetail()
          }
        })
      }).catch(() => {
        this.showToast('已取消')
      })
    },
    //  评价
    goComment () {
      this.$router.push({path: '/myorder/comment', query: {orderId: this.item.orderId, type: this.type}})
    },
    //  退款详情
    returnDetail () {
      this.$router.push({path: '/returnDetail', query: {orderId: this.item.orderId, type: this.type}})
    },
    // 取消退款
    cancelReturn (item) {
      this.$dialog.confirm({
        title: '提示',
        message: '确定取消退款吗？',
        confirmButtonColor: this.m_color
      }).then(() => {
        let data = {
          orderId: item.orderId,
          type: this.type
        }
        cancelrefundOrder(data).then(res => {
          if (res.result === '0') {
            this.showToast('取消退款成功')
            this.$router.go(0)
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
 /*订单*/
  .order_item{
    width: 92%;
    margin: 2% auto 0;
    padding: 0 3%;
    border-radius: 4%;
  }
  .good{
    padding: 3% 0;
    display: flex;
    align-items: flex-start;
  }
  .good .left{
    width: 30%;
    padding-top: 30%;
    position: relative;
    border-radius: 4%;
  }
  .good .left img{
    position: absolute;
    top: 0;
    left:  0;
    width: 100%;
    height: 100%;
  }
  .good .right{
    width: 68%;
    line-height: 1.8;
  }
  .order_item .bot{
    line-height: 3;
  }
  .order_item .sbot{
    padding: .3rem 0;
    display: flex;
    justify-content: flex-end;
  }
  .order_item .sbot .gray_btn,.order_item .sbot .red_btn{
    border-radius: .1rem;
    border: 1px solid #f0f0f0;
    padding: .05rem .2rem;
    margin: 0 .2rem;
  }
  .shop_tit{
    line-height: 2.4;
  }
  .shop_tit .beneif{
      margin-left: .2rem
  }
  .credit{
    display: flex;
    background: #f7f7f7;
    width: 100%;
    padding: .2rem .1rem;
    border-radius: .2rem
  }
  .middle{
      padding: .3rem 0;
      color: #777;
      line-height: 2
  }
  .s_bot{
      padding: .2rem 0 .4rem
  }
   .plane{
   }
  .plane .middle{
    align-items: flex-start;
    padding: .3rem .1rem;
  }
   .plane .middle .left{
     margin-right: .3rem;
   }
   .plane .middle .right{
     width: 90%;
   }
   .plane .middle .beneif{
     line-height: 1.5;
     margin-right: .3rem;
   }
   .plane .s_bot{
     padding-top: .3rem;
   }
  .plane .s_bot .btn{
    border: 1px solid #f7f7f7;
    padding: 0 .1rem;
    border-radius: .1rem;
  }
 .card{
   width: 92%;
   padding: 0 4%;
   border-radius: .2rem;
   margin: .4rem auto 0;
   box-shadow: 0 0 .1rem rgba(99,99,99,.2);
 }
 .card>div{
   line-height: 1rem;
 }
 .card .gray_f{
   padding-left: .2rem;
 }
</style>



// WEBPACK FOOTER //
// src/components/order.vue